// extracted by mini-css-extract-plugin
module.exports = {"banner":"iYNrp_yh","slider-item":"aB_QXzMk","section":"S8dPTg9N","title":"FRpYDmX4","subtitle":"__56lonG4c","desc":"TEZlcpwL","btn":"qQ_XGMzk"};